module.exports = __webpack_public_path__ + "img/机器人行业数字化转型场景图谱.f421ff9d.jpg";